import React, { ReactNode, Dispatch, SetStateAction } from 'react'
import { hideMenu } from 'assets/Icons'
import { useLocation } from 'react-router-dom'
import { Icon } from 'assets/index'
import { Container, ToggleButton, Content } from './style'

interface SearchMenuProps {
  children: ReactNode
  isExpanded: boolean
  setIsExpanded: Dispatch<SetStateAction<boolean>>
}

const SearchMenu: React.FC<SearchMenuProps> = ({
  children,
  isExpanded,
  setIsExpanded,
}) => {
  const location = useLocation()
  const isFinancePage = location.pathname.includes('/financeiro')
  const toggleMenu = () => {
    setIsExpanded((prev: boolean) => !prev)
  }

  return (
    <Container isExpanded={isExpanded}>
      <ToggleButton
        type="button"
        className="extendButton"
        onClick={toggleMenu}
        data-testid="search-menu-toggle-btn"
        isExpanded={isExpanded}
      >
        <img
          src={Icon('chevron_left.svg')}
          alt="extend menu"
          className="icon"
        />
      </ToggleButton>
      <Content isExpanded={isExpanded} isFinancePage={isFinancePage}>
        {children}
      </Content>
    </Container>
  )
}

export default SearchMenu
